// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mdku","largestCol":"styles_largestCol__k3ise","smallestCol":"styles_smallestCol__9NptA"};